import React from "react";
import { Header, TopBar } from "../components/Header";
import { Footer } from "../components/Footer";
import FAQ from "../components/FAQ";
import { HottestDealsSlider } from "../components/Slider";
import aboutData from "../app/data/aboutData";


export function About() 
{


  return(

    <div className='container-fluid' >

      {/* _____________________SECTION HEADER ABOUT ___________________ */} 
      
      <div className='row'> <TopBar /> </div>
      <div className='row sticky-top'> <Header page={4} /> </div>
            
      {/* __________________ SECTION 1 ABOUT _______________  */}

      <div className='row pt-5 justify-content-center'>
        <div className='col-lg-11'>  
          <HottestDealsSlider />
        </div>
      </div>

      {/* ____________________ SECTION 2 ABOUT _____________________ */}

      <section className='row py-4 justify-content-center'>
        <div className='col-lg-11'>    
          <div className='row py-5 justify-content-center'>
            <div className='col-md-6'>  
              <div className="card p-4 mb-4">
                <div className="card-body">
                  <h5 className="card-title mb-3">Expertise et support sur mesure</h5>
                  <p className="card-text text-secondary">
                    Faites confiance à ORTÉGA pour bénéficier d’un accompagnement complet : fourniture, installation et maintenance de vos équipements, ainsi que des solutions logicielles adaptées à vos besoins spécifiques.
                  </p>
                </div>
              </div>   
            </div>
            <div className='col-md-6'>  
              <div className="card p-4">
                <div className="card-body">
                  <h5 className="card-title mb-3">Fiabilité et réactivité</h5>
                  <p className="card-text text-secondary">
                    Avec ORTÉGA, bénéficiez d’un service rapide et fiable pour la fourniture, l’installation et la maintenance de vos équipements, ainsi que pour vos solutions logicielles.
                  </p>
                </div>
              </div>   
            </div>
          </div>
        </div>
      </section>

      
      {/* _____________________SECTION 3 ABOUT ___________________ */} 

      <section className='row justify-content-center'>
        <div className='col-lg-11'>
          
          <div className="container pb-5 startup-section">
            <div className="row justify-content-between align-items-center pb-5">
        
              {/* Colonne de Gauche : Texte + Grille */}
              <div className="col-lg-6">
                <div className="header-text mb-5">
                  <h2 className="fw-bold display-6 mb-0">Pourquoi choisir ORTEGA</h2>
                  <p className="text-muted small border-top pt-2 d-inline-block">
                    Des services fiables, un accompagnement expert et des solutions adaptées.
                  </p>
                </div>

                <div className="row g-4">
                  { aboutData.features.map((item) => (
                    <div key={item.id} className="col-md-6">
                      <div className="feature-card text-center p-4 text-white" style={{ backgroundColor: item.bg }}>
                        <div className="icon-box mb-3">
                          <i className={`bi ${item.icon}`}></i>
                        </div>
                        <h5 className="fw-bold mb-2">{item.title}</h5>
                        <p className="small mb-0 opacity-75">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Colonne de Droite : Image avec bordure orange */}
              <div className="col-lg-5 mt-5 mt-lg-0 text-center">
                <div className="image-decoration-wrapper position-relative d-inline-block">
                  <img src="./img/ortega-img.png" alt="Reading person" className="img-fluid main-startup-img" />
                  <div className="orange-border-frame"></div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>
  
      {/* _____________________SECTION 4 ABOUT ___________________ */} 

      <div className='row justify-content-center bg-light-gray py-5'>
        <div className='col-md-11'>
          <div className="d-flex flex-column">
            <h2 className="fw-bold fs-1 mb-2">FAQ : Votre Support ORTEGA</h2>
            <span className="p-1 bg-green" style={{ width: '15%' }} ></span>
            <p className="text-muted pt-2 d-inline-block">
              Découvrez comment ORTEGA accompagne entreprises, structures de santé et particuliers avec ses services et équipements.
            </p>
          </div>
        </div>
        <div className='col-md-11 py-4'>
          <FAQ />
        </div>
      </div>

       {/* _____________________SECTION FOOTER ABOUT ___________________ */} 

      <div className='row'>
        <Footer />
      </div>
      
    </div>

  )
}

